import Marquee from "react-fast-marquee";
import { BRAND_LOGOS } from "../../data/site";

export const BrandMarquee = () => (
  <div data-testid="brand-marquee" className="py-16 border-y hairline bg-white">
    <p className="overline-x text-center mb-10" style={{ color: "#1e2a36" }}>Trusted manufacturing partners</p>
    <Marquee speed={28} gradient gradientColor="#ffffff" gradientWidth={120} autoFill>
      {BRAND_LOGOS.map((b) => (
        <div key={b.name} className="mx-12 flex items-center">
          <img
            src={b.src}
            alt={`${b.name} logo`}
            loading="lazy"
            className="h-20 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
          />
        </div>
      ))}
    </Marquee>
  </div>
);
